import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import $ from 'jquery';
import { pick } from 'underscore';
import { BackboneInstanceWrapper } from '@bingads-webui-react/backbone-instance-wrapper';
import { Callout } from '@bingads-webui-react/callout';
import { AccountList } from '@bingads-webui-campaign-react/shared-library-scopes';

export class PopupCallout extends React.PureComponent {
  constructor(props) {
    super(props);
    if (props.view) {
      props.view.on('closePopup', this.close);
    }
  }

  close = () => {
    if (this.props.view) {
      this.props.view.off('closePopup');
    }
    this.props.close();
  };

  render() {
    const { target } = this.props;
    const { right } = target.getBoundingClientRect();
    const calloutMaxWidth = 325; // this value is defined in global style
    const placement = right + calloutMaxWidth > window.innerWidth ? 'left' : 'right';

    return (
      <div onMouseLeave={this.close}>
        <Callout
          {...pick(this.props, 'title', 'content', 'target', 'popoverClassName')}
          placement={placement}
          show
          popoverId={this.props.popoverId}
          closeButton={false}
        />
      </div>
    );
  }
}

PopupCallout.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.element.isRequired,
    PropTypes.string.isRequired,
  ]).isRequired,
  /**
   * the content element or text of the callout
   */
  content: PropTypes.oneOfType([
    PropTypes.element.isRequired,
    PropTypes.string.isRequired,
  ]).isRequired,
  /**
   * target of the callout, DOM element
   */
  target: PropTypes.instanceOf(Element).isRequired,
  /**
   * function called to remove callout
   */
  close: PropTypes.func.isRequired,
  /**
   * callout id
   */
  popoverId: PropTypes.string.isRequired,
  /**
   * view that has event triggered to close the popup
   */
  view: PropTypes.shape({
    on: PropTypes.func.isRequired,
    off: PropTypes.func.isRequired,
  }),

  popoverClassName: PropTypes.string,
};

PopupCallout.defaultProps = {
  view: null,
  popoverClassName: undefined,
};

export function showPopup({
  containerSelector,
  event,
  popoverId = 'popup-callout',
  title,
  contentView,
  parentView,
  popoverClassName,
}) {
  const container = $(containerSelector);
  container.show();
  const containerDOM = container.get(0);
  contentView.once('rendered', () => {
    const contentViewReactWrapper = <BackboneInstanceWrapper instance={contentView} />;
    ReactDOM.render(
      <PopupCallout
        title={title}
        content={contentViewReactWrapper}
        target={event.target}
        close={() => {
          ReactDOM.unmountComponentAtNode(containerDOM);
        }}
        view={parentView}
        popoverId={popoverId}
        popoverClassName={popoverClassName}
      />
      , containerDOM
    );
  });
}

export function showAccountListPopup({
  i18n,
  containerSelector,
  event,
  popoverId = 'popup-callout',
  title,
  subtitle,
  value: {
    Accounts,
    Customers,
    Others,
  },
  parentView,
}) {
  const container = $(containerSelector);
  container.show();
  const containerDOM = container.get(0);
  const content = (
    <AccountList
      i18n={i18n}
      description={subtitle}
      accounts={{
        adAccounts: Accounts,
        managerAccounts: Customers,
        others: Others,
      }}
    />);
  ReactDOM.render(
    <PopupCallout
      title={title}
      content={content}
      target={event.target}
      close={() => {
        ReactDOM.unmountComponentAtNode(containerDOM);
      }}
      view={parentView}
      popoverId={popoverId}
    />
    , containerDOM
  );
}
